"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DmsFilePicker = void 0;
var _react = _interopRequireWildcard(require("react"));
var _sweetalert = _interopRequireDefault(require("sweetalert2"));
var _DmsButton = require("../DmsButton/DmsButton");
var _DmsTableCreateButton = require("../DmsTableButton/DmsTableCreateButton");
var _DmsTableEditButton = require("../DmsTableButton/DmsTableEditButton");
var _DmsTableDeleteButton = require("../DmsTableButton/DmsTableDeleteButton");
var _DmsButtonGroup = require("../DmsButtonGroup/DmsButtonGroup");
var _DmsTable = require("../DmsTable/DmsTable");
var _DmsFetch = require("../DmsFetch/DmsFetch");
var _HttpStatus = require("../../constants/HttpStatus");
var _DmsPermissions = require("../DmsPermissions/DmsPermissions");
var _reactBootstrap = require("react-bootstrap");
var _DmsTokenHook = require("../DmsTokenHook/DmsTokenHook");
var _reactIntlUniversal = _interopRequireDefault(require("react-intl-universal"));
var _reactToastify = require("react-toastify");
var _Folder = _interopRequireDefault(require("@mui/icons-material/Folder"));
var _FolderOpen = _interopRequireDefault(require("@mui/icons-material/FolderOpen"));
var _Archive = _interopRequireDefault(require("@mui/icons-material/Archive"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const DmsFilePicker = _ref => {
  let {
    id,
    value = null,
    onChange = path => {},
    isDirectory = false,
    readOnly = false,
    extensions = [],
    show_hidden = false,
    read = true,
    write = false,
    run = false,
    needs_authentication = true
  } = _ref;
  const token = (0, _DmsTokenHook.getToken)();
  const table = (0, _react.useRef)(null);
  const [show, setShow] = (0, _react.useState)(false);
  const [current, setCurrent] = (0, _react.useState)(null);
  const [currentPath, setCurrentPath] = (0, _react.useState)(value);
  const [currentIsDir, setCurrentIsDir] = (0, _react.useState)(true);
  const baseUrl = '/file_system';
  let filter = {
    only_dir: isDirectory,
    show_hidden: show_hidden,
    extensions: extensions,
    path: value
  };
  let filter_query = encodeURIComponent(JSON.stringify(filter));
  const [filters, setFilters] = (0, _react.useState)(filter_query);
  const [url, setUrl] = (0, _react.useState)(baseUrl + "/table?filter=" + filter_query);
  const checkPermissions = async item => {
    let _filter = _objectSpread(_objectSpread({}, filter), {}, {
      path: item.path
    });
    let _filter_query = encodeURIComponent(JSON.stringify(_filter));
    let endpoint = baseUrl + "/permissions?filter=" + _filter_query;
    let response = null;
    const name = item.name;
    if (needs_authentication) {
      response = await (0, _DmsFetch.fetchData)(endpoint, "GET", token);
    } else {
      response = await (0, _DmsFetch.fetchData)(endpoint, "GET");
    }
    if (response.status == _HttpStatus.HTTP_STATUS.OK_200) {
      const permissions = response.data.data;
      if (run && !permissions.run) {
        let msg = _reactIntlUniversal.default.get("NameIsNotRunable", {
          name
        }).d("{name} is not runnable");
        _reactToastify.toast.error(msg, {
          position: "top-right"
        });
      } else if (write && !permissions.write) {
        let msg = _reactIntlUniversal.default.get("NameIsNotWritable", {
          name
        }).d("{name} is not writable");
        _reactToastify.toast.error(msg, {
          position: "top-right"
        });
      } else if (read && !permissions.read) {
        let msg = _reactIntlUniversal.default.get("NameIsNotReadable", {
          name
        }).d("{name} is not readable");
        _reactToastify.toast.error(msg, {
          position: "top-right"
        });
      } else {
        onChange(currentPath);
        setShow(false);
      }
    } else {
      _sweetalert.default.fire({
        icon: 'error',
        title: response.data.detail
      });
    }
  };
  const changeItem = async item => {
    if (!item.is_directory) {
      setCurrentPath(item.path);
      setCurrentIsDir(item.is_directory);
      setCurrent(item);
    } else {
      filter.path = item.path;
      filter_query = encodeURIComponent(JSON.stringify(filter));
      let endpoint = baseUrl + "/current?filter=" + filter_query;
      let response = null;
      if (needs_authentication) {
        response = await (0, _DmsFetch.fetchData)(endpoint, "GET", token);
      } else {
        response = await (0, _DmsFetch.fetchData)(endpoint, "GET");
      }
      if (response.status == _HttpStatus.HTTP_STATUS.OK_200) {
        item = response.data.data;
        setCurrentPath(item.path);
        setCurrentIsDir(item.is_directory);
        setCurrent(item);
        if (item.is_directory) {
          filter.path = item.path;
          filter_query = encodeURIComponent(JSON.stringify(filter));
          setUrl(baseUrl + "/table?filter=" + filter_query);
          setFilters(filter_query);
          table.current.setPage(1);
        }
      } else {
        _sweetalert.default.fire({
          icon: 'error',
          title: response.data.detail
        });
      }
    }
  };
  const handleItem = item => {
    changeItem(item);
  };
  const handleSelect = async (e, data) => {
    if (current != null) checkPermissions(current);else {
      onChange(currentPath);
      setShow(false);
    }
  };
  const handleCancel = async (e, data) => {
    setShow(false);
  };
  (0, _react.useEffect)(() => {
    if (table.current) table.current.updateTable();
  }, [url, currentPath]);
  let header = [{
    label: _reactIntlUniversal.default.get("Name").d("Name"),
    column_name: "name",
    filter: false,
    function: (value, item, column_name) => {
      return /*#__PURE__*/_react.default.createElement("a", {
        href: "#",
        onClick: event => {
          event.preventDefault();
          handleItem(item);
        }
      }, /*#__PURE__*/_react.default.createElement("span", {
        style: {
          width: '20px',
          display: 'inline-block'
        }
      }, item.is_directory ? /*#__PURE__*/_react.default.createElement(_Folder.default, null) : null), value);
    }
  }, {
    label: _reactIntlUniversal.default.get("Permissions").d("Permissions"),
    function: (value, item) => {
      return /*#__PURE__*/_react.default.createElement("div", {
        style: {
          display: 'flex',
          justifyContent: 'space-around',
          fontSize: '12px',
          margin: '0 20px'
        }
      }, /*#__PURE__*/_react.default.createElement("i", {
        className: item.read ? "fas fa-eye" : "fa fa-fw"
      }), /*#__PURE__*/_react.default.createElement("i", {
        className: item.write ? "fas fa-pen" : "fa fa-fw"
      }), /*#__PURE__*/_react.default.createElement("i", {
        className: item.run ? "fas fa-terminal" : "fa fa-fw"
      }));
    },
    control: 'hidden',
    filter: false,
    width: "140px"
  }, {
    label: _reactIntlUniversal.default.get("Created").d("Created"),
    column_name: "created_on",
    function: date => moment(date).format("D/MM/YYYY HH:mm:ss"),
    control: 'hidden',
    filter: false,
    width: "180px"
  }, {
    label: _reactIntlUniversal.default.get("Updated").d("Updated"),
    column_name: "updated_on",
    function: date => moment(date).format("D/MM/YYYY HH:mm:ss"),
    control: 'hidden',
    filter: false,
    width: "180px"
  }];
  if (!readOnly) {
    header.push({
      label: _reactIntlUniversal.default.get("Actions").d("Actions"),
      permissions: ['CAN_EDIT_FILE_SYSTEM'],
      width: "80px",
      sortable: false,
      element: row => {
        const name = row.name;
        return /*#__PURE__*/_react.default.createElement(_DmsButtonGroup.DmsButtonGroup, null, /*#__PURE__*/_react.default.createElement(_DmsTableEditButton.DmsTableEditButton, {
          table: table,
          title: _reactIntlUniversal.default.get("Update_name", {
            name
          }).d("Update {name}"),
          url: baseUrl,
          queryData: 'filter=' + filters,
          button_icon: "edit"
        }), /*#__PURE__*/_react.default.createElement(_DmsTableDeleteButton.DmsTableDeleteButton, {
          table: table,
          title: _reactIntlUniversal.default.get("Delete_name", {
            name
          }).d("Delete {name}"),
          text: _reactIntlUniversal.default.get("DmsFilePicker.DeleteButtonMessage", {
            name
          }).d("The item {name} will be deleted. Are you sure about it?"),
          url: baseUrl,
          queryData: 'filter=' + filters
        }));
      }
    });
  }
  let title = isDirectory ? _reactIntlUniversal.default.get("SelectAFolder").d("Select a folder") : _reactIntlUniversal.default.get("SelectAFile").d("Select a file");
  title += " - " + _reactIntlUniversal.default.get("Current").d("Current") + ": " + currentPath.split(['/', '\\']).pop();
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "input-group",
    style: {
      display: 'flex'
    }
  }, /*#__PURE__*/_react.default.createElement("input", {
    type: "text",
    id: id,
    value: value,
    className: "form-control",
    disabled: true,
    style: {
      borderTopRightRadius: 0,
      borderBottomRightRadius: 0
    }
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "input-group-append"
  }, /*#__PURE__*/_react.default.createElement(_DmsButton.DmsButton, {
    icon: isDirectory ? /*#__PURE__*/_react.default.createElement(_FolderOpen.default, null) : /*#__PURE__*/_react.default.createElement(_Archive.default, null)
    // variant="dark"
    ,
    style: {
      borderTopLeftRadius: 0,
      borderBottomLeftRadius: 0
    },
    onClick: () => setShow(true)
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Modal, {
    show: show,
    size: "xl",
    fullscreen: "xl-down"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.ModalHeader, null, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      display: 'flex',
      width: '100%'
    }
  }, /*#__PURE__*/_react.default.createElement("h5", {
    className: "modal-title",
    style: {
      flexGrow: 1
    }
  }, title), !readOnly && isDirectory ? /*#__PURE__*/_react.default.createElement(_DmsPermissions.DmsPermissions, {
    permissions: ['CAN_EDIT_FILE_SYSTEM']
  }, /*#__PURE__*/_react.default.createElement(_DmsTableCreateButton.DmsTableCreateButton, {
    table: table,
    title: _reactIntlUniversal.default.get("CreateFolder").d("Create folder"),
    url: baseUrl,
    queryData: 'filter=' + filters,
    header: header,
    variant: "dark"
  })) : null)), /*#__PURE__*/_react.default.createElement(_reactBootstrap.ModalBody, null, /*#__PURE__*/_react.default.createElement(_DmsTable.DmsTable, {
    url: url,
    header: header,
    needs_authentication: needs_authentication,
    ref: table,
    managed: true,
    export_table: false,
    initial_sort: "name ASC"
  })), /*#__PURE__*/_react.default.createElement(_reactBootstrap.ModalFooter, null, /*#__PURE__*/_react.default.createElement(_DmsButton.DmsButton, {
    variant: "primary",
    onClick: handleSelect,
    text: _reactIntlUniversal.default.get("Select").d("Select"),
    disabled: isDirectory ? !currentIsDir : currentIsDir
  }), /*#__PURE__*/_react.default.createElement(_DmsButton.DmsButton, {
    variant: "secondary",
    text: _reactIntlUniversal.default.get("Cancel").d("Cancel"),
    onClick: handleCancel
  }))))));
};
exports.DmsFilePicker = DmsFilePicker;